/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-separator.vue?vue&type=template&id=019f89dc&scoped=true"
import script from "./pc-separator.vue?vue&type=script&lang=js"
export * from "./pc-separator.vue?vue&type=script&lang=js"
import style0 from "./pc-separator.vue?vue&type=style&index=0&id=019f89dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f89dc",
  null
  
)

export default component.exports